import React from "react";
import Test from "./test";

const info = {
  difficulty: "easy",
  title: "Element with K frequency",
  url: "element-k-frequency",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {any []} arr
* @param {number} k
* @return {any}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function kFrequency(arr, k) {
  // your code goes here        
};
`,
};

export default info;
